import { render, staticRenderFns } from "./marketplace.vue?vue&type=template&id=014d1d42&scoped=true"
import script from "./marketplace.vue?vue&type=script&lang=js"
export * from "./marketplace.vue?vue&type=script&lang=js"
import style0 from "./marketplace.vue?vue&type=style&index=0&id=014d1d42&prod&scoped=true&lang=css"
import style1 from "./marketplace.vue?vue&type=style&index=1&id=014d1d42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014d1d42",
  null
  
)

export default component.exports